<template>
    <div>
        <header>
            <div class="banner">
                <img class="back-icon" @click="back"
                     src="@/assets/theme/light/status/01dailyActive/01back.svg">
                <div class="search-box">
                    <van-icon class="search-icon" color="#CACED5" name="search" size="22" />
                    <van-field v-model="keyWord" :placeholder="$t('actionLibrary.searchDesc')"/>
                </div>
            </div>
        </header>
        <div class="content">
            <div class="select-box">
                <div class="left-box">
                    <div class="left-item">
                        <div class="left-item-text " :class="{ 'active': selectIndex == 1 }" @click="selectType(1)">{{$t('actionLibrary.action1')}}</div>
                    </div>
                    <div class="left-item">
                        <div class="left-item-text" :class="{ 'active': selectIndex == 2 }" @click="selectType(2)">{{$t('actionLibrary.action2')}}</div>
                    </div>
                    <div class="left-item">
                        <div class="left-item-text":class="{ 'active': selectIndex == 3 }" @click="selectType(3)">{{$t('actionLibrary.action3')}}</div>
                    </div>
                    <div class="left-item">
                        <div class="left-item-text":class="{ 'active': selectIndex == 4 }" @click="selectType(4)">{{$t('actionLibrary.action4')}}</div>
                    </div>
                    <div class="left-item">
                        <div class="left-item-text":class="{ 'active': selectIndex == 5 }" @click="selectType(5)">{{$t('actionLibrary.action5')}}</div>
                    </div>
                    <div class="left-item">
                        <div class="left-item-text":class="{ 'active': selectIndex == 6 }" @click="selectType(6)">{{$t('actionLibrary.action6')}}</div>
                    </div>
                    <div class="left-item">
                        <div class="left-item-text":class="{ 'active': selectIndex == 7 }" @click="selectType(7)">{{$t('actionLibrary.action7')}}</div>
                    </div>
                    <div class="left-item">
                        <div class="left-item-text":class="{ 'active': selectIndex == 8 }" @click="selectType(8)">{{$t('actionLibrary.action8')}}</div>
                    </div>
                </div>
                <div class="right-box">
                    <div class="customize-box" v-if="selectIndex == 8" @click="toAddAction">
                        <div class="customize-title">{{$t('actionLibrary.customize')}}</div>
                        <div class="customize-desc">{{$t('actionLibrary.customizeDesc')}}</div>
                        <img class="customize-icon" src="@/assets/theme/light/trainPlan/01planEdit/01add.svg">
                    </div>
                    <div v-for="(item) in instrumentList" v-if="item.actionList.length > 0">
                        <div class="instrument">{{ item.name }}</div>
                        <van-row class="line" gutter="10">
                            <van-col span="11" v-for="(action) in item.actionList" :key ="action.actionId">
                                <div class="action-item-box" :class="{'active': action.selected == 1}" @click="clickAction(action)">
                                    <img class="action-icon" :src="action.bannerUrl">
                                    <div class="action-name">{{ getNameByLang(action) }}</div>
                                    <div class="action-introduce-box">
                                        <div class="action-introduce" @click="toActionDesc(action.actionId)">{{ $t('actionLibrary.detailBtn') }}</div>
                                    </div>
                                    <img class="selected-icon" v-if="action.selected == 1" src="@/assets/theme/light/trainPlan/02actionLibrary/01selected.svg">
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </div>
        </div>
        <div class="confirm-box" v-if="selectAction.length > 0" @click="returnPlanEdit">{{$t('actionLibrary.confirm')}} ({{selectAction.length}})</div>
    </div>
</template>

<script>
import {getActionListByType} from "../../api/trainPlan";

export default {
    name: 'actionLibrary',
    data() {
        return {
            selectIndex: 1,
            keyWord: '',
            customize: 0,
            instrumentList: [],
            actionTypeId: 1,
            selectAction: [],
            lang: '',
            currentActionCount: 0,
            theme: 'light',
        }
    },
    mounted() {
        this.getActionListByType();
        if (this.$route.query.currentActionCount) {
            this.currentActionCount = this.$route.query.currentActionCount;
        }
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme;
        }
    },
    watch: {
        $route(to, from) {
            // 在路由改变时重新加载数据
            this.getActionListByType();
            if (this.$route.query.currentActionCount) {
                this.currentActionCount = this.$route.query.currentActionCount;
            }
        }
    },
    methods: {
        back() {
            this.$router.back()
        },
        selectType(index) {
            this.selectIndex = index;
            if (index == 8) {
                this.customize = 1;
                this.actionTypeId = ''
            } else {
                this.customize = 0;
                this.actionTypeId = index;
            }
            this.getActionListByType()
        },
        getActionListByType() {
            this.instrumentList = []
            this.$api.trainPlan.getActionListByType({
                keyWord: this.keyWord,
                customize: this.customize,
                actionTypeId: this.actionTypeId,
            }).then(res => {
                this.dealResult(res.info)
            })
        },
        getNameByLang(item) {
            if (this.$i18n.locale == 'zh') {
                return item.actionName
            } else if (this.$i18n.locale == 'en') {
                return item.actionNameEn
            } else if (this.$i18n.locale == 'ja') {
                return item.actionNameJa
            }
            return item.actionName;
        },
        dealResult(result) {
            console.log(this.selectAction)
            for (let i = 0; i < result.length; i++) {
                // 检查 selectAction 中是否存在与 result[i] 匹配的项
                const selectedAction = this.selectAction.find(selectedItem => selectedItem.actionId === result[i].actionId);
                if (selectedAction) {
                    this.$set(result[i], 'selected', 1);
                } else {
                    this.$set(result[i], 'selected', 0);
                }
            }
            for (let i = 1; i < 25; i++) {
                let instrument = {
                    name: this.$t('actionLibrary.instrument' + i),
                    actionList: []
                }
                for (let j = 0; j < result.length; j++) {
                    if (result[j].instrumentType) {
                        let instrumentType = result[j].instrumentType.split(',')
                        for (let k = 0; k < instrumentType.length; k++) {
                            if (instrumentType[k] == i) {
                                instrument.actionList.push(result[j])
                            }
                        }
                    }
                }
                this.instrumentList.push(instrument)
            }
        },
        clickAction(item) {
            console.log(this.selectAction.length)
            console.log(this.currentActionCount)
            let total = parseInt(this.selectAction.length) + parseInt(this.currentActionCount);
            console.log(total)
            if (total >= 10 && item.selected == 0) {
                this.$toast({
                    message: this.$t('actionLibrary.maxTip'),
                    duration: 1000
                })
                return;
            }
            if (item.selected == 1) {
                this.$set(item, 'selected', 0);
                const index = this.selectAction.findIndex(selectedItem => selectedItem.actionId === item.actionId);
                if (index !== -1) {
                    this.selectAction.splice(index, 1);
                }
            } else {
                this.$set(item, 'selected', 1);
                const index = this.selectAction.findIndex(selectedItem => selectedItem.actionId === item.actionId);
                if (index === -1) {
                    this.selectAction.push(item);
                    console.log(this.selectAction);
                }
            }
        },
        toActionDesc(actionId) {
            event.stopPropagation();
            this.$router.push({
                name: 'actionDesc',
                query: {
                    actionId: actionId,
                    lang: this.$i18n.locale,
                    theme: this.theme
                }
            })
        },
        toAddAction() {
            this.$router.push({
                name: 'actionEdit',
                query: {
                    lang: this.$i18n.locale,
                    theme: this.theme
                }
            })
        },
        returnPlanEdit() {
            // 将参数保存到 localStorage
            localStorage.setItem('selectedActionList', JSON.stringify(this.selectAction));
            this.selectAction = [];
            this.$router.go(-1);
        }
    }
}
</script>

<style scoped>
.banner {
    display: flex;
}
.search-box {
    width: 316px;
    height: 40px;
    background: var(--bg-color-2);
    border-radius: 10px 10px 10px 10px;
    display: flex;
    align-items: center;
}

.search-icon {
    padding: 0 4px 0 11px;
}

/deep/ .van-cell {
    padding: 0;
}

.back-icon {
    margin-right: 6px;
}

.content {
    width: 100%;
    margin-top: 98px;
}

.left-box {
    width: 80px;
    overflow: hidden;
}

.left-item {
    height: 50px;
    display: flex;
    align-items: center;
}

.left-item-text {
    font-size: 13px;
    color: var(--text-color-2);
    padding-left: 14px;
}

.left-item-text.active {
    width: 80px;
    height: 37px;
    background: #DAEDE5;
    border-radius: 0px 19px 19px 0px;
    color: var(--chart-color-1);
    display: flex;
    align-items: center;
}

.right-box {
    width: calc(100% - 80px);
    height: calc(100vh - 98px);
    margin-left: 15px;
    overflow-y: auto;
}

.select-box {
    display: flex;
    height: 100%;
}

.action-item-box {
    width: 126px;
    height: 141px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    text-align: center;
    margin-bottom: 14px;
    border: 2px solid var(--bg-color-2);
    position: relative;
}

.selected-icon {
    position: absolute;
    width: 44px;
    height: 44px;
    top: -1px;
    right: -1px;
}

.instrument {
    font-size: 17px;
    color: var(--text-color-1);
    margin-left: 15px;
    margin-top: 9px;
    margin-bottom: 10px;
}

.line {
    margin-bottom: 14px;
}

.action-icon {
    width: 121px;
    height: 68px;
    margin-top: 12px;
}

.action-name {
    font-size: 13px;
    color: var(--text-color-1);
    margin-top: -5px;
    width: 100%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* 设置行数 */
    -webkit-box-orient: vertical;
}

.action-introduce {
    font-size: 11px;
    color: var(--text-color-2);
    background: var(--bg-color-1);
    border-radius: 11px 11px 11px 11px;
    padding: 5px 12px;
    display: inline-block;
}

.action-introduce-box {
    display: flex;
    justify-content: center;
    justify-items: center;
    margin-top: 6px;
}

.action-item-box.active {
    border-radius: 13px 13px 13px 13px;
    border: 2px solid var(--chart-color-1);
}

.confirm-box {
    width: 375px;
    height: 56px;
    background: var(--bg-color-2);
    position: absolute;
    bottom: 0;
    font-size: 17px;
    line-height: 56px;
    text-align: center;
}

.customize-box {
    width: 265px;
    height: 68px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    position: relative;
}

.customize-title {
    font-size: 15px;
    color: var(--text-color-1);
    position: absolute;
    left: 16px;
    top: 13px
}

.customize-desc {
    font-size: 12px;
    color: var(--text-color-2);
    position: absolute;
    left: 16px;
    top: 38px
}

.customize-icon {
    width: 23px;
    height: 23px;
    position: absolute;
    right: 17px;
    top: 23px;
}

/deep/ .van-cell {
    background-color: var(--bg-color-2);
}

/deep/ .van-field__control {
    color: var(--text-color-1);
}
</style>


// WEBPACK FOOTER //
// src/views/trainPlan/02actionLibrary.vue